import React from "react";
import { Tabs, PageHeader } from "antd";
import { Competence } from "./competence";
import { CompetenceType } from "./competenceType";
const { TabPane } = Tabs;

export function CompetencePage() {
    return (
        <>
            <PageHeader title="Lista Competências" />
            <Tabs defaultActiveKey="1">
                <TabPane tab="Tipos de Competência" key="1">
                    <CompetenceType />
                </TabPane>
                <TabPane tab="Competências" key="2">
                    <Competence />
                </TabPane>
            </Tabs>
        </>
    );
}
